/* eslint-disable */
import React, { FC } from 'react';
import CaretDown16 from '@carbon/icons-react/es/caret--down/16';
import CaretUp16 from '@carbon/icons-react/es/caret--up/16';
import { Attachments } from 'components/molecules/attachments';
import { Collapse, Panel } from 'components/atoms/collapse';

export const DemoAttachmentPage: FC = () => {
  const onUploadAttachment = (file) => {
    console.log(file);
    // Call the upload attachment api
    return new Promise((resolve) => resolve('hello'));
  };
  return (
    <>
      <h3>Sample attachment list</h3>
      <Attachments.List data={[]} onUploadRequest={onUploadAttachment} />
      <h3>Within a panel</h3>
      <Collapse
        expandIconPosition="right"
        expandIcon={({ isActive }) => {
          return isActive ? <CaretDown16 /> : <CaretUp16 />;
        }}
        ghost
      >
        <Panel key="attachments" header={'Header'}>
          <Attachments.List data={[]} onUploadRequest={onUploadAttachment} />
        </Panel>
      </Collapse>
    </>
  );
};
